// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer___2nhzB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = 1222
// module chunks = 1